const API_BASE = '/api/email';

export const EMAIL_API = {
  BASE_URL: API_BASE,
  CONTACT: `${API_BASE}/contact`,
  TRAINING: `${API_BASE}/contact` // Using same endpoint for both forms
} as const;